import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year3/Autumn/PlaceValue/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'PlaceValue',
  field: 'Number',
  weeks: [1, 3],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/PlaceValue/1RepresentNumbersTo100" */ './1RepresentNumbersTo100'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/PlaceValue/2PartitionNumbersTo100" */ './2PartitionNumbersTo100'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/PlaceValue/3NumberLineTo100" */ './3NumberLineTo100'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(/* webpackChunkName: "Year3/Autumn/PlaceValue/4Hundreds" */ './4Hundreds')
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/PlaceValue/5RepresentNumbersTo1000" */ './5RepresentNumbersTo1000'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/PlaceValue/6PartitionNumbersTo1000" */ './6PartitionNumbersTo1000'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/PlaceValue/7FlexiblePartitioningOfNumbersTo1000" */ './7FlexiblePartitioningOfNumbersTo1000'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/PlaceValue/8HundredsTensAndOnes" */ './8HundredsTensAndOnes'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/PlaceValue/9Find1To100MoreOrLess" */ './9Find1To100MoreOrLess'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/PlaceValue/10NumberLineTo1000" */ './10NumberLineTo1000'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/PlaceValue/11EstimateOnANumberLineTo1000" */ './11EstimateOnANumberLineTo1000'
        )
    }),
    // Step 12
    newSmallStepContent({
      ...BlockModel.smallSteps[11],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/PlaceValue/12CompareNumbersTo1000" */ './12CompareNumbersTo1000'
        )
    }),
    // Step 13
    newSmallStepContent({
      ...BlockModel.smallSteps[12],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Autumn/PlaceValue/13OrderNumbersTo1000" */ './13OrderNumbersTo1000'
        )
    }),
    // Step 14
    newSmallStepContent({
      ...BlockModel.smallSteps[13],
      module: () =>
        import(/* webpackChunkName: "Year3/Autumn/PlaceValue/14CountIn50s" */ './14CountIn50s')
    })
  ]
});
export default Block;
